<template lang="pug">
div.mylist--current
  template(v-if="size >= 3")
    div.mylist--summary
      | {{myListNames.slice(0, 2).join('、')}}、他{{size - 2}}件
  template(v-else-if="size <= 2 && size > 0 ")
    div.mylist--summary
      | {{myListNames.slice(0, 2).join('、')}}
</template>

<script>

export default {
  props: {
    myLists: {
      type: Array,
      default: () => ([])
    },
    size: {
      type: Number,
      default: 0
    },
  },
  computed: {
    myListNames: function() {
      return this.myLists.map((myList) => myList.name);
    }
  }
};
</script>
